import { useEffect } from 'react';

import Grid from '@mui/material/Grid';

import { ensureDefined } from '@e-socna/utils';

import { useContextualizedFields } from '../../../../hooks/useContextualizedFields.hook';

import type { CostUsageForm_CostUsage } from '../../fragments/cost-usage.fragment';

import { Selection } from './Selection';

interface Props {
  readonly formContext?: string;
  readonly id: string;
  readonly setIsUsingCosts: (isUsing: boolean) => void;
}

export const CostsSelectionFormStep = ({
  formContext,
  setIsUsingCosts,
}: Readonly<Props>) => {
  const fields = useContextualizedFields<
    Readonly<{
      costUsages: readonly CostUsageForm_CostUsage[] | undefined;
    }>
  >(
    {
      costUsages: {
        id: 'cost-usages-selection',
        name: 'costUsages',
      },
    },
    formContext,
  );

  const { costUsages } = ensureDefined({
    costUsages: fields.costUsages.value,
  });

  useEffect(() => {
    setIsUsingCosts(!!costUsages.length);
  }, [costUsages, setIsUsingCosts]);

  return (
    <Grid container sx={{ height: '100%', display: 'flex', flexGrow: 1 }}>
      <Grid size={12} sx={{ display: 'flex', flexDirection: 'column' }}>
        <Selection costUsages={costUsages} fieldName={fields.costUsages.name} />
      </Grid>
    </Grid>
  );
};
